'use client';

import { motion } from 'framer-motion';
import type { ReactNode } from 'react';
import { SPRING_GENTLE } from './constants';

interface StaggerItemProps {
  className?: string;
  children: ReactNode;
}

const itemVariants = {
  hidden: { opacity: 0, y: 8 },
  visible: { opacity: 1, y: 0, transition: SPRING_GENTLE },
};

export function StaggerItem({ className, children }: StaggerItemProps) {
  return (
    <motion.div variants={itemVariants} className={className}>
      {children}
    </motion.div>
  );
}
